import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-[transform,box-shadow,background-color,color,border-color] duration-300 active:scale-[0.98]";

const Arrow = () => (
  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
);

export const BtnPrimary = ({ to, href, children, className = "", arrow = true, ...rest }) => {
  const cls = `${base} bg-grad text-white shadow-[0_10px_30px_-10px_rgba(79,111,214,0.6)] hover:shadow-[0_18px_40px_-12px_rgba(79,111,214,0.75)] hover:-translate-y-0.5 ${className}`;
  const inner = (<>{children}{arrow && <Arrow />}</>);
  if (href) return <a href={href} className={cls} {...rest}>{inner}</a>;
  return <Link to={to} className={cls} {...rest}>{inner}</Link>;
};

export const BtnGhost = ({ to, href, children, className = "", arrow = true, ...rest }) => {
  const cls = `${base} border border-ink/15 text-ink hover:bg-ink hover:text-white hover:border-ink ${className}`;
  const inner = (<>{children}{arrow && <Arrow />}</>);
  if (href) return <a href={href} className={cls} {...rest}>{inner}</a>;
  return <Link to={to} className={cls} {...rest}>{inner}</Link>;
};
